var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhilippines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95435 31.0457 4.57764e-05 20 4.57764e-05C8.95431 4.57764e-05 0 8.95435 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 1.52588e-05V20L5.85785 34.1422C9.47715 37.7614 14.4771 40 20 40C31.0457 40 40 31.0456 40 20C40 8.95439 20 1.52588e-05 20 1.52588e-05Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 1.52588e-05C14.4771 1.52588e-05 9.47715 2.23861 5.85785 5.85783C10.7649 10.7649 12.5068 12.5069 20 20H40C40 8.95439 31.0457 1.52588e-05 20 1.52588e-05Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6947 20L11.2522 18.8511L12.5529 16.4855L9.90052 16.9929L9.56443 14.3135L7.71693 16.2841L5.86951 14.3135L5.53334 16.9929L2.88107 16.4854L4.18177 18.8511L1.7392 20L4.18177 21.1489L2.88107 23.5144L5.53357 23.0071L5.86943 25.6865L7.71693 23.7158L9.56443 25.6865L9.90052 23.0071L12.5527 23.5145L11.2521 21.149L13.6947 20Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33383 7.8261L6.14664 8.96227L7.47828 8.54047L6.64875 9.66453L7.46156 10.8007L6.13609 10.3592L5.30664 11.4832L5.31703 10.0863L3.99164 9.64477L5.32351 9.22297L5.33383 7.8261Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33383 28.5168L6.14664 29.653L7.47828 29.2311L6.64875 30.3553L7.46156 31.4914L6.13609 31.0499L5.30664 32.1739L5.31703 30.7771L3.99164 30.3355L5.32351 29.9137L5.33383 28.5168Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9271 18.1715L16.1144 19.3076L14.7827 18.8857L15.6122 20.0098L14.7994 21.1461L16.1248 20.7045L16.9544 21.8285L16.9439 20.4317L18.2693 19.9901L16.9375 19.5684L16.9271 18.1715Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilippines);
export default __webpack_public_path__ + "static/media/philippines.29833b5120ca83413eea41f2fbdabf1c.svg";
export { ForwardRef as ReactComponent };